<template>
  <div>
    <el-card class="mb5">
      <div style="margin-bottom: 10px">
        <!-- 导出 -->
        <el-button
          v-permit:remove="'btn:expressTrackingList:export'"
          size="small"
          type="primary"
          @click="allExportOrder"
        >
          {{ $t('newOrder.export') }}
        </el-button>
      </div>
    </el-card>
    <el-card>
      <!--  表格数据  -->
      <el-table
        ref="tableRef"
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        row-key="id"
        style="width: 100%"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'stateName'">
              <el-tag type="success">{{ $t('customerManagements.enable') }}</el-tag>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('collectionCenter.Note')" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="toEdit(scope.row)">{{ $t('collectionCenter.edit') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

    </el-card>
    <el-dialog
      :title="$t('collectionCenter.Note')"
      :visible.sync="noteVisible"
      width="30%"
      :before-close="noteClose"
    >
      <el-form ref="remarkFormRef" :model="remarkForm" @submit.native.prevent>
        <el-form-item
          prop="remark"
          :rules="[
            {
              required: true,
              message: $t('collectionCenter.pleaseInput'),
              trigger: ['blur', 'change']
            },
            {
              min: 0,
              max: 300,
              message: $t('collectionCenter.outRange'),
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input
            v-model="remarkForm.remark"
            :placeholder="$t('collectionCenter.pleaseInput')"
            clearable
            maxlength="300"
            show-word-limit
            @blur="filRemark"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noteClose">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button type="primary" @click="noteSubmit">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList';
import { trackExport, trackPage, trackEditRemark } from '@/api/newExpressAPI';

export default {
  name: 'ExpressTrackingList',
  data() {
    return {
      noteVisible: false,
      remarkForm: {},
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      tableData: [],
      tableHeaderList: [
        // 轨迹节点
        {
          id: 1,
          label: this.$t('home.trackingNode'),
          prop: 'trackStatus',
          cloWidth: '150',
          center: 'center'
        },
        // 操作类型
        {
          id: 2,
          label: this.$t('home.trackingNodeCode'),
          prop: 'stateCode',
          cloWidth: '150',
          center: 'center'
        },
        // 数字代码
        {
          id: 3,
          label: '数字代码(localTrackCode)',
          prop: 'sort',
          cloWidth: '140',
          center: 'center'
        },
        // 中文描述
        {
          id: 4,
          label: this.$t('home.chineseDescription'),
          prop: 'stateCn',
          cloWidth: '170',
          center: 'center'
        },
        // 葡语描述
        {
          id: 5,
          label: this.$t('home.portugueseDescription'),
          prop: 'statePu',
          cloWidth: '170',
          center: 'center'
        },
        // 是否对外
        {
          id: 6,
          label: this.$t('home.isPublic'),
          prop: 'isOpenOutside',
          cloWidth: '140',
          center: 'center'
        },
        // 对外-中文描述
        {
          id: 7,
          label: this.$t('home.publicChineseDescription'),
          prop: 'outsideStateCn',
          cloWidth: '170',
          center: 'center'
        },
        // 葡语描述
        {
          id: 8,
          label: this.$t('home.publicPortugueseDescription'),
          prop: 'outsideStatePu',
          cloWidth: '170',
          center: 'center'
        },
        // 状态
        {
          id: 9,
          label: this.$t('trajectory.state'),
          prop: 'status',
          cloWidth: '140',
          center: 'center'
        }
      ],
      customerList: [] // 用户列表
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getSearch();
  },
  methods: {
    filRemark() {
      this.remarkForm.remark = this.remarkForm.remark.trim();
    },
    toEdit(row) {
      this.remarkForm = {
        id: row.id,
        remark: row.remark
      };
      this.noteVisible = true;
      if (this.$refs.remarkFormRef) {
        this.$refs.remarkFormRef.clearValidate();
      }
    },
    noteClose() {
      this.remarkForm = {};
      if (this.$refs.remarkFormRef) {
        this.$refs.remarkFormRef.clearValidate();
      }
      this.noteVisible = false;
    },
    noteSubmit() {
      this.$refs.remarkFormRef.validate((valid) => {
        if (valid) {
          if (this.remarkForm.remark) {
            trackEditRemark(this.remarkForm).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
                this.noteClose();
                this.getSearch();
              }
            });
          } else {
            this.$message({
              message: this.$t('collectionCenter.nullSubmit'), // '无数据提交'
              type: 'warning'
            });
          }
        }
      });
    },
    // 查询
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber
      };
      trackPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          console.log(this.tableData, ' this.tableData');
        }
      });
    },
    allExportOrder() {
      const data = {};
      trackExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>

<style lang="scss" scoped></style>
